import React from 'react';
import { cmsUrlToFrontendOrigin } from 'modules/cms-url-to-frontend-origin';

export const LinkFromCms = ({ url, title }) => {
  return <a href={cmsUrlToFrontendOrigin(url)}>{title}</a>;
};
